import { CursorStyle } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";

export const WrapperLogo = styled("div")({
  cursor: CursorStyle.pointer,
});
